export default __webpack_public_path__ + "static/media/explore-desktop-2.dfe57626.png";